import { Vector3 } from "@babylonjs/core";

export function yawFromVelocity(velocity: Vector3): number { return Math.atan2(velocity.x, velocity.z); }
export function wrappedAngleDifference(current:number,target:number):number{return Math.atan2(Math.sin(target-current),Math.cos(target-current));}
export function shortestYawStep(current: number, target: number, maximumStep: number): number {
  const difference = wrappedAngleDifference(current,target);
  return current+Math.max(-maximumStep,Math.min(maximumStep,difference));
}
